/**
 * Touch Panel deployment delivery API (Phase 5).
 * Frontend never publishes MQTT — backend delivers prepared payloads.
 */

import { get, post } from '../api/apiClient';

const BASE = '/api/v2/touch-panels';

/**
 * Deliver a prepared deployment to one or more Edge Agents.
 * @param {string} deploymentId
 * @param {{ tenantId: string, deviceIds?: string[], operationId?: string, requireOnline?: boolean }} body
 */
export async function deliverTouchPanelDeployment(deploymentId, body) {
  const response = await post(`${BASE}/deployments/${encodeURIComponent(deploymentId)}/deliver`, body);
  if (response?.success === false) {
    const err = new Error(response.error || 'Deploy failed');
    err.code = response.code;
    err.details = response.details;
    throw err;
  }
  return response;
}

/**
 * List per-device delivery records for a deployment.
 */
export async function listTouchPanelDeliveries(deploymentId, tenantId) {
  const qs = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : '';
  const response = await get(
    `${BASE}/deployments/${encodeURIComponent(deploymentId)}/deliveries${qs}`
  );
  if (response?.success === false) {
    throw new Error(response.error || 'Failed to load deliveries');
  }
  return response.deliveries || [];
}
